export default class ProgressCircle {
    private mArc: Phaser.GameObjects.Arc;
    private mRadius: number = 20;

    public FillColor: number = 0x004CFF;
    public AlphaColor: number = 0.5;

    private mValue: number = 0;
    private mTotalValue: number = 0;

    constructor(scene: Phaser.Scene, x: number, y: number, totalValue: number) {
        this.mArc = new Phaser.GameObjects.Arc(scene, x, y, this.mRadius, 0, 360, false, this.FillColor, this.AlphaColor);
        this.mArc.setDepth(10000);
        this.mValue = totalValue;
        this.mTotalValue = totalValue;
        scene.add.existing(this.mArc);
    }


    public SetPosition(x: number, y: number) {
        this.mArc.setPosition(x, y);
    }

    public Update(amount: number) {
        this.mValue = amount;

        if (this.mValue < 0) {
            this.mValue = 0;
        } else if (this.mValue > this.mTotalValue) {
            this.mValue = this.mTotalValue;
        }
        this.updatePercentage();
    }

    public Reset(){
        this.Update(0);
    }

    public Increase(amount: number) {
        this.mValue += amount;

        if (this.mValue >= this.mTotalValue) {
            this.mValue = this.mTotalValue;
        }
        this.updatePercentage();

        return (this.mValue === this.mTotalValue);
    }

    public Decrease(amount: number) {
        this.mValue -= amount;

        if (this.mValue < 0) {
            this.mValue = 0;
        }

        this.updatePercentage();
        return (this.mValue === 0);
    }

    public Clear() {
        this.mArc.clearFX();
        this.mArc.clearMask();
    }

    public Destroy() {
        this.mArc.destroy();
    }

    private updatePercentage() {
        let percent = this.mValue * 100 / this.mTotalValue;
        let endAngleDegrees = 360 * percent / 100;
        this.mArc.setEndAngle(endAngleDegrees);
    }

}
